import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Arizona State Portal": {
    parameters: {
      linkUrls: ["https://my.azdeq.gov/mydeq-settings/oauth2/authorization/okta"],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: false,
          receipt: false,
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "AZ",
  },
  "Arizona - Send to Customer to Certify": {
    parameters: {
      staffInputs: {
        fees: false,
        documentTypes: {
          invoice: false,
          receipt: false,
          report: false,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "AZ",
  },
  "Arizona - Download Report": {
    parameters: {
      linkUrls: ["https://my.azdeq.gov/mydeq-settings/oauth2/authorization/okta"],
      staffInputs: {
        fees: false,
        documentTypes: {
          invoice: false,
          receipt: false,
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "AZ",
  },
};
